import dompurify from 'dompurify';
import sanitizeHtml from 'sanitize-html';

// NOTE: This expects references to have a PREFIXED TOKEN format ... something like:
// - cmsg_19asd9fi9123ASdfj
// - case_129jadsfjk123
// This filtering currently only supports cmsg_ prefixed tokens
const REF_REGEX = new RegExp(/[R|r]ef:\s{0,1}[a-z]{0,6}_[a-zA-Z0-9]+/);
const withoutThreadRef = (text: string) => text.replace(REF_REGEX, '');

export const generateDefaultEmailBody = (fromEmailAddress?: string) => {
  return `\n\n\n\n----\nPlease reply directly to this email to ensure your message is routed to the correct ticket. Messages sent directly to ${fromEmailAddress} are not monitored.`;
};

export const textOnly = (html: string) => {
  const text = dompurify.sanitize(html, { ALLOWED_TAGS: [], KEEP_CONTENT: true });
  return withoutThreadRef(text);
};

export const htmlContainsAnchor = (html: string) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.querySelectorAll('a').length > 0;
};

export const sanitizeHtmlEmail = (html: string) => {
  return sanitizeHtml(html ?? '', {
    allowedTags: ['b', 'em', 'i', 'strong', 'u', 'br', 'span', 'a'],
    allowedAttributes: {
      // by default href attributes are validated to ensure they only contain http, https, ftp, mailto, and tel URLs.
      a: ['href'],
      span: ['aria-hidden', 'style'], // Hides case message routing token in email module
    },
    allowedStyles: {
      span: {
        // Match HEX and RGB
        color: [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
      },
    },
    // forbid the use of protocol-relative URLs (starting with //) to access another site using the current protocol
    allowProtocolRelative: false,
  });
};
